import React from 'react';
import Fade from 'react-reveal/Fade';

import Countdown from 'react-countdown-now';

import './MultipleChoiceInteraction.css';

import { Button } from '@material-ui/core';

import {Col, Row} from 'reactstrap';

// toast
import 'react-toastify/dist/ReactToastify.css';

// toast component
import { toast, ToastContainer} from 'react-toastify';
import CustomCheckbox from '../../common/CustomCheckbox';

import {createItemJson, currentLessonAttempt, currentLesson} from '../../common/services';

import {dateToString} from '../../common/utils';


interface Istate {
  completiontext: any;
  oncomplete: any;
  demomode: boolean;
  interactionid: any,
  introtext: any;
  lessonid: any;
  penalty: number;
  question: any;
  answers: any;
  show: boolean;
  submittext: any;
  timelimit: number;
}
 
function randomId () {
    const reqlen = 5;
    let text = "tempdf_";
    const possible = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < reqlen; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

class MultipleChoiceInteraction extends React.Component<Istate> {

  public state = {
    answer: true,
    answers: this.props.answers as any[],
    chosenans: '',
    completed: false,
    completiontext: this.props.completiontext,
    demomode: this.props.demomode,
    introtext: this.props.introtext,
    penalty: this.props.penalty,
    question: this.props.question,
    quiz: false,
    quizlaunchtime: Date.now() + 5000,
    tries: 1,
    score: 0,
    show: false,
    showTimer: false,
    timelimit: this.props.timelimit * 1000,
    disabledButton: false
  }

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.process = this.process.bind(this);
    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
  }

  public handleClick() {
    this.setState({ show: !this.state.show });
  }

  public handleAnswerSelected(event) {
    console.log("EVENT CURRENT VALUE"+ event.currentTarget.value);
    this.setState({chosenans: event.currentTarget.value, disabledButton: false});
  }

  public handleGenCreatedItemLoaded (res) {
    console.log(res);
    if(res.code ===200 || res.code ===201){ 
      this.setState({completed: true, disabledButton: true})

      // toast(this.state.completiontext)

      setTimeout(this.props.oncomplete(), 1500);
    }
    else {
      toast.error('Please try again');
    }
  }

  
  public process() {
    const timeTaken = (Date.now() - this.state.quizlaunchtime) / 1000.0;
    const penalty = (timeTaken - (this.state.timelimit / 1000.0)) * this.state.penalty; 

    const newtries = this.state.tries + 1;
    this.setState({tries: newtries});

    console.log('newtries: ' + this.state.tries);

    const item = {
          time_start: dateToString(this.state.quizlaunchtime),
          time_end: dateToString(Date.now()),
          tries_count: this.state.tries,
          lesson: this.props.lessonid,
          interaction: this.props.interactionid,
          answer: [
            this.state.chosenans
          ]
    }
    
    if (!this.state.demomode) {
      const currentlesson = currentLesson();
      createItemJson( 'interaction_attempts/?attemptid=' + currentlesson.sessionKey, item, text => this.handleGenCreatedItemLoaded(text));
    }
    else {
      // toast.info(this.props.completiontext);
      console.log(this.state.chosenans)

      setTimeout(this.props.oncomplete(), 1500);
    }
    
    console.log(item);
    
  }

  public render() {

    const grid = 8;

    return (
      <div
        style={{ color: "white" }}
        className="multichoice-component-container"
      >
        <div className="multichoice-exercise-details">
          <Fade when={!this.state.quiz}>
            <p className="multichoice-intro-text" style={{ display: !this.state.quiz ? "flex" : "none" }}>{this.props.introtext}</p>
          </Fade>
          <Fade when={this.state.quiz && !this.state.completed}>
            <div>
              <p className="multichoice-question">{this.state.question}</p>
              <ul>
                {this.props.answers.map((answer, idx) => (
                  <li className="multichoice-answer" key={idx}>
                    
                    <CustomCheckbox 
                      id={idx}
                      type="radio"
                      dispvalue={answer.answer_text}
                      value={answer.id}
                      onChange = {this.handleAnswerSelected} 
                      name="answer"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </Fade>

          <Fade when={this.state.completed}>
            <div style={{ display: !this.state.completed ? "initial" : "none" }}>
              <p className="exercise-complete">{this.state.completiontext}</p>
            </div>
          </Fade>
        <Fade when={this.state.quiz}>
        <button
            className="submit-interaction submit-multichoice"
            onClick={this.process}
            disabled = {this.state.disabledButton}
            style={{ display: this.state.quiz ? "block" : "none" }}
          >
            {this.props.submittext}
          </button>
        </Fade>
          
        </div>

        {/* <div className="multichoice-duration-details"> */}
          <Fade when={this.state.show === false}>
          <div className="multichoice-duration-details" style={{ display: !this.state.show ? "flex" : "none" }}>
            <p className="right" >
              Your quiz begins in:
              <Countdown
                date={this.state.quizlaunchtime}
                // tslint:disable-next-line jsx-no-lambda
                onComplete={() => {
                  this.setState({
                    show: true,
                    quiz: true,
                    showTimer: true
                  });
                }}
              />
            </p>
            </div>
          </Fade>
        {/* </div> */}
      </div>
    );
  }
}
export default MultipleChoiceInteraction;



// WEBPACK FOOTER //
// ./src/components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component.tsx